import type { ClientDevice } from '@maru44/huntre-utils/src/models/clientDevice'
import type { ClientMember } from '@maru44/huntre-utils/src/models/clientMember'
import type { ClientSubGroup, ClientSubGroupInput } from '@maru44/huntre-utils/src/models/clientSubGroup'
import { Dialog, DialogContent, DialogTitle } from '@mui/material'
import { useCallback } from 'react'
import { ClientSubGroupForm } from 'src/components/forms/ClientSubGroupForm'

type Props = {
  open: boolean
  onClose: () => void
  onSubmit: (v: ClientSubGroupInput) => Promise<void>
  initialValue?: ClientSubGroup
  clientDevices: ClientDevice[]
  clientMembers: ClientMember[]
  warningMessage?: string
}

export const ClientSubGroupFormDialog = ({ open, onClose, onSubmit, initialValue, clientDevices, clientMembers, warningMessage }: Props) => {
  const handleSubmit = useCallback(
    async (v: ClientSubGroupInput) => {
      await onSubmit(v)
      onClose()
    },
    [onSubmit, onClose],
  )

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>{initialValue ? 'サブグループの編集' : 'サブグループの作成'}</DialogTitle>
      <DialogContent>
        <ClientSubGroupForm
          initialValue={initialValue}
          clientDevices={clientDevices}
          clientMembers={clientMembers}
          warningMessage={warningMessage}
          submitLabel={initialValue ? '更新' : '作成'}
          onSubmit={handleSubmit}
          onCancel={onClose}
        />
      </DialogContent>
    </Dialog>
  )
}
